import { ReactComponent as SvgChevron } from '@img/icons/nav-arrow-right.svg';
import { ReactComponent as SvgPhone } from '@img/icons/nav-mobile-phone.svg';
import { ReactComponent as SvgShowroom } from '@img/icons/nav-mobile-showroom.svg';
import { ReactComponent as SvgUser } from '@img/icons/nav-mobile-user.svg';
import * as React from 'react';
import FeaturedLinkCard from '../NavigationDesktop/FeaturedLinkCard/FeaturedLinkCard';
import S from './NavigationMobile.styles';
const NavigationMobile = (props) => {
    const [activeList, setActiveList] = React.useState();
    // Reset state if navigation is toggled.
    React.useEffect(() => {
        if (props.isActive) {
            setActiveList(undefined);
        }
    }, [props.isActive]);
    // Render top level navigation...
    if (!activeList) {
        return renderDefault();
    }
    // ...or current level.
    return renderLevel(activeList);
    /**
     * Render the top-level layout.
     * @returns
     */
    function renderDefault() {
        return (React.createElement(S.Container, { "data-m-active": props.isActive, "aria-hidden": !props.isActive, "aria-label": "Main Navigation - Mobile", "data-scroll-active": props.scrollActive },
            React.createElement(S.List, null, props.items.map((item) => (React.createElement(S.Item, { key: item.id },
                React.createElement(S.Link, { href: item.url, tabIndex: props.isActive ? 0 : -1, target: item.target, onClick: (event) => {
                        if (!!item.children?.length || !!item.featured?.length) {
                            event.preventDefault();
                            setActiveList(item);
                        }
                    } },
                    React.createElement(S.Text, null, item.text),
                    (!!item.children?.length || !!item.featured?.length) && (React.createElement(S.Arrow, { as: SvgChevron }))))))),
            React.createElement(S.Divider, null),
            React.createElement(S.QuickLinkList, null,
                React.createElement(S.QuickLink, { href: props.authUrl },
                    React.createElement(S.QuickLinkIcon, { as: SvgUser }),
                    props.isAccountArea ? 'Log out' : props.isAuthenticated ? 'My Account' : 'Log In'),
                props.contactLink && props.contactLink.url && props.contactLink.text && (React.createElement(S.QuickLink, { href: `tel:${props.contactLink.text}`, target: props.contactLink.target },
                    React.createElement(S.QuickLinkIcon, { as: SvgPhone }),
                    "Call Us")),
                props.locationLink && props.locationLink.url && props.locationLink.text && (React.createElement(S.QuickLink, { href: props.locationLink.url, target: props.locationLink.target },
                    React.createElement(S.QuickLinkIcon, { as: SvgShowroom }),
                    props.locationLink.text)))));
    }
    /**
     * Render the layout for the current active item (last in stack).
     * @returns
     */
    function renderLevel(activeItem) {
        return (React.createElement(S.Container, { "data-m-active": props.isActive, "data-is-level": true },
            React.createElement(S.Header, null,
                React.createElement(S.Back, { onClick: (event) => {
                        event.preventDefault();
                        setActiveList(undefined);
                    } },
                    React.createElement(SvgChevron, null),
                    React.createElement("span", null, "Back"))),
            React.createElement(S.List, { "data-active-link": true },
                React.createElement(S.Item, null,
                    React.createElement(S.Link, { href: activeItem.url, target: activeItem.target },
                        React.createElement(S.Text, null, activeItem.text)))),
            activeItem.featured?.length && (React.createElement(S.FeaturedCardsContainer, null, activeItem.featured.map((item) => (React.createElement(FeaturedLinkCard, { key: item.id, ...item }))))),
            activeItem.children?.length && (React.createElement(S.List, null, activeItem.children.map((item) => (React.createElement(React.Fragment, null, !!item.text && item.url !== null && (React.createElement(S.Item, { key: item.id },
                React.createElement(S.Link, { href: item.url, target: item.target },
                    React.createElement(S.Text, null, item.text)))))))))));
    }
};
export default NavigationMobile;
